export default function(h, row, index) {
    if (row.medical)
        return <i class="fa fa-plus-square text-danger" title="санаторий/лечебное учреждение"></i>
    else
        return <i class="fa fa-hotel text-primary" title="отель/гостиница"></i>
}